var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4096,
    height: 2046,
    viewBox: "0 0 4096 2046",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M1370.5 1670H932V1067.78H1087.03V967H1325.66V1496.3H1370.5V1670Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M360 1522.88V878H1088V1069.26H932.117V1670H499.561V1522.88H360Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M932.933 85H360V878H1088V691.219H932.933V85Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M1341 85H932V692.225H1086.19V771H1341V85Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M1610.88 85H1341V769.974H1497.89V788H1649V688.859H1745V85H1610.88Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: 6,
    d: "M1685.5 788H1649.5V689H1744.5L1748.81 85H2190V229.938H2156.01V858.714H2028.63V879H1685.5V788Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: 7,
    d: "M2029.14 879.136L1685.5 879.136V984.72L1646 984.72V1087.5H1737.89V1670H2155V861H2029.14V879.136Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: 8,
    d: "M2455.96 877.275H2708L2702.68 1083.28H2610.16V1673L2155 1669.87V865H2455.96V877.275Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: 9,
    d: "M2455.18 865.174H2155V230.819H2189.6V156H2583.46V688.281H2708V878H2455.18V865.174Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: 10,
    d: "M2977.33 158.889L2583 156V687.558H2710.19V792.436H2806.51V835H3014V237.468H2977.33V158.889Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: 11,
    d: "M3130.72 835H3014.32V236.289H2979L2979 108H3412.1V207.584H3421V684.912H3235.08V790.712H3130.72V835Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: 12,
    d: "M3846.24 108H3412.41V208.726H3420.87L3422.5 686.405H3236V876H4007V565.754H3927.17V386.009H3846.24V108Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: 13,
    d: "M3237 1014V876H4007V1182.99H3936.19V1363.43H3853.4V1523H3411.5V1097.5H3250.5V1014H3237Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: 14,
    d: "M2975 1523H3412V1097.75H3250.4V1013.29H3237.28V960H2976.39V1056H2973.5V1101.5H3001.47V1470H2975V1523Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor3);
export default __webpack_public_path__ + "static/media/select-floor-3.3ccc441c.svg";
export { ForwardRef as ReactComponent };